import { render, staticRenderFns } from "./call_info.vue?vue&type=template&id=c7c21746&scoped=true&"
import script from "./call_info.vue?vue&type=script&lang=js&"
export * from "./call_info.vue?vue&type=script&lang=js&"
import style0 from "./call_info.vue?vue&type=style&index=0&id=c7c21746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c21746",
  null
  
)

export default component.exports